import { App } from "vue";
import { io, Socket } from "socket.io-client";
import JwtService from "@/services/JwtService";

/**
 * @description service to handle socket connections
 */
class SocketService {
    /**
     * @description property to share vue instance
     */
    public static vueInstance: App<Element>;

    /**
     * @description Socket.io client instance
     */
    private static socket: Socket;

    /**
     * @description initialize socket connection
     */
    public static init(app: App<Element>): void {
        SocketService.vueInstance = app;
        SocketService.vueInstance.config.globalProperties.$socket = SocketService.socket;

        // const baseUrl = 'http://localhost:3008'; // Remplacer avec l'URL de ton serveur WebSocket
        const baseUrl = 'https://api.anagem.esogema.bj'; // Remplacer avec l'URL de ton serveur WebSocket
        SocketService.socket = io(baseUrl, {
            transports: ['websocket', 'polling'],
            auth: {
                token: JwtService.getToken(),
            },
        });

        // Event listeners
        SocketService.socket.on('connect', () => {
            console.log('Socket connected');
        });

        SocketService.socket.on('disconnect', () => {
            console.log('Socket disconnected');
        });

        SocketService.socket.on('error', (error: any) => {
            console.error('Socket error:', error);
        });
    }

    /**
     * @description send a message to a specific channel
     * @param channel: string
     * @param data: any
     */
    public static emit(channel: string, data: any): void {
        if (SocketService.socket.connected) {
            SocketService.socket.emit(channel, data);
        } else {
            console.error('Socket is not connected');
        }
    }

    /**
     * @description listen for messages from a specific channel
     * @param channel: string
     * @param callback: function
     */
    public static on(channel: string, callback: (data: any) => void): void {
        SocketService.socket.on(channel, (data: any) => {
            callback(data);
        });
    }

    /**
     * @description disconnect the socket connection
     */
    public static disconnect(): void {
        if (SocketService.socket.connected) {
            SocketService.socket.disconnect();
        }
    }

    /**
     * @description reconnect the socket connection
     */
    public static reconnect(): void {
        if (!SocketService.socket.connected) {
            SocketService.socket.connect();
        }
    }
}

export default SocketService;
